import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import type { AlertData } from './alert-data.type';

@Component({
  templateUrl: './alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, TranslocoPipe],
})
export class AlertComponent {
  readonly data = inject<AlertData>(MAT_SNACK_BAR_DATA);

  readonly icon = computed(() => {
    switch (this.data.type) {
      case 'success':
        return 'check_circle_outline';
      case 'warning':
        return 'error_outline';
    }
  });

  readonly color = computed(() => {
    switch (this.data.type) {
      case 'success':
        return '';
      case 'warning':
        return 'warn';
    }
  });
}
